import styled from 'styled-components';
import { CloseButton } from '../CloseButton/CloseButton';

export const ModalCloseButton = styled(CloseButton).attrs({
  'aria-label': 'Close',
})`
  position: absolute;
  top: 18px;
  right: 18px;
`;
